// extracted by mini-css-extract-plugin
export var tabHeadingContainer = "schema-tabs-component-module--tabHeadingContainer--b0d6d";
export var tabHeadingItem = "schema-tabs-component-module--tabHeadingItem--f0be0";